import GoldenButterImage from "~/images/golden-butter.png";

type GoldHostBadgeProps = {
  className?: string;
  label?: string;
};

export function GoldHostBadge({ className = "", label = "Gold host" }: GoldHostBadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md bg-[#FED558]/30 backdrop-blur-sm px-1.5 py-1.5 ${className}`}
    >
      <img
        src={GoldenButterImage}
        alt=""
        className="h-4 w-4 flex-shrink-0"
        aria-hidden
      />
      <span className="font-sans font-bold text-xs text-[#E8A91D]">
        {label}
      </span>
    </span>
  );
}
